import utils from '../helpers/utils'

export default {
  request: function (req, token) {
    if (typeof token !== 'undefined') {
      if (utils.isJSON(token)) {
        const tokens = JSON.parse(token)
        this.options.http.setHeaders.call(this, req, { Authorization: 'Bearer ' + tokens.access_token })
      } else {
        if (typeof token === 'string') {
          this.options.http.setHeaders.call(this, req, { Authorization: 'Bearer ' + token })
        }
      }
    }
  },

  response: function (res) {
    if (res.data) {
      // return token and refresh token
      if (res.data.access_token && res.data.refresh_token) {
        if (res.data.ttl && !res.data.expires) {
          res.data.expires = res.data.ttl
        }
        return JSON.stringify(res.data)
      }
    }
  }
}
